import type { ButtonHTMLAttributes, ReactNode } from 'react';

import { Spinner } from './Spinner';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger';
  loading?: boolean;
  /** Accessible label for the inline spinner shown while `loading` is set. */
  loadingLabel?: string;
  children: ReactNode;
}

/** Accessible button with an inline loading state. */
export function Button({
  variant = 'primary',
  loading = false,
  loadingLabel = 'Working…',
  disabled,
  children,
  className,
  type = 'button',
  ...rest
}: ButtonProps) {
  const classes = [
    'zs-button',
    variant === 'secondary' ? 'zs-button--secondary' : '',
    variant === 'danger' ? 'zs-button--danger' : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled === true || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? <Spinner label={loadingLabel} /> : children}
    </button>
  );
}
